import { render, staticRenderFns } from "./uat.vue?vue&type=template&id=273d42e1&"
import script from "./uat.vue?vue&type=script&lang=js&"
export * from "./uat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports